import React,{ Component } from 'react';

import {
  Button,
  FormGroup,
  Input,
  FormText
} from 'reactstrap';

import find from 'lodash/find';

import TextInput from '../../../shared/components/TextInput';
import ColorInput from '../../../shared/components/ColorInput';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import Form from '../../../shared/components/Form';
import TutorialPopover from '../../../shared/components/TutorialPopover';

const CREATE_NEW_BRAND_OPTION = '__CREATE_NEW_BRAND_OPTION__';

class CampaignBrandForm extends Component {
  constructor(){
    super();

    this.state = {
      logo:null,
      color:null,
      validationMessages:{},
      selectedValue:CREATE_NEW_BRAND_OPTION,
      isShowingPopover:false
    };
  }

  componentWillMount(){
    const {
      activeBrandId,
      possibleBrands,
      allowingBrandEditingInline
    } = this.props;

    if(activeBrandId){
      this.setState({selectedValue:activeBrandId});
    } else if(possibleBrands.length > 0 && !this.props.allowingBrandEditingInline){
      this.setState({selectedValue:possibleBrands[0].id})
    }

    if(allowingBrandEditingInline){
      const brandBeingEdited = find(possibleBrands,(b) => b.id === activeBrandId) || {};

      this.setState({
        logo:{
          fileName:brandBeingEdited['logoFileName'],
          id:brandBeingEdited['logoId'],
          large:brandBeingEdited['logoURL'],
          thumbnail:brandBeingEdited['logoThumbnailURL'],
        },
        color:brandBeingEdited['primaryColor']
      });
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      console.log('SHOW POPOVER IN HALF A SECOND')
      window.setTimeout(() => {
        console.log('SHOW THE POPOVER');
        this.setState({isShowingPopover:true});
      },500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }

    if(nextProps.activeBrandId !== this.props.activeBrandId){
      this.setState({selectedValue:nextProps.activeBrandId});
    }
  }


  handleSubmit(data){
    const validationMessages = {};

    if(!data.companyId || data.companyId === CREATE_NEW_BRAND_OPTION){
      data.companyId = CREATE_NEW_BRAND_OPTION;

      if(!data.brandName || data.brandName.length === ''){
        validationMessages['brandName'] = 'Name is required';
      }

      if(!this.state.logo || (this.state.logo && !this.state.logo.fileName)){
        validationMessages['brandLogo'] = 'Logo is required';
      }

      if(!this.state.color){
        validationMessages['brandColor'] = 'Color is required';
      }
      
    } else if(this.props.allowingBrandEditingInline){}

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit({
        ...data,
        brandLogo:this.state.logo,
        brandColor:this.state.color
      });
    }
  }

  render(){
    const { validationMessages, selectedValue, isShowingPopover } = this.state;

    const { possibleBrands, allowingBrandEditingInline, isShowingTutorial, canCreateNew } = this.props;

    const isCreatingBrand = selectedValue === CREATE_NEW_BRAND_OPTION;

    const brandBeingEdited = find(possibleBrands, (b) => b.id === selectedValue) || {};

    return (
      <Form 
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={isShowingPopover && isShowingTutorial}
          target='BrandPopoverTarget'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Add your brand'
        >
          <p>
            Add brand info that your audience will see.
          </p>
        </TutorialPopover>
        <div id='BrandPopoverTarget'>
          {(possibleBrands.length > 0 && !allowingBrandEditingInline) && (
            <FormGroup>
              <Input
                id='BrandPopoverTarget'
                type='select'
                name='companyId'
                value={selectedValue}
                onChange={(e) => this.setState({selectedValue:e.target.value})}
              >
                {possibleBrands.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
                { canCreateNew && <option value={CREATE_NEW_BRAND_OPTION}>Create a new Brand</option> }
              </Input>
              {validationMessages['companyId'] && (
                <FormText className='DangerFeedback'>
                  {validationMessages['companyId']}
                </FormText>
              )}
            </FormGroup>
          )}
          {(possibleBrands.length === 0 || isCreatingBrand || allowingBrandEditingInline) && (
            <div>
              <TextInput
                name='brandName'
                placeholder='Brand Name'
                warning={validationMessages['brandName']}
                defaultValue={brandBeingEdited['name']}
                maxLength={40}
              />
              <ColorInput
                placeholder='Primary Brand Color'
                onChange={(color) => this.setState({color:color})}
                warning={validationMessages['brandColor']}
                defaultValue={brandBeingEdited['primaryColor']}
              />
              <DroppableFileInput
                text='Upload Brand Logo'
                name='logo'
                fileType='image'
                onChange={(logo) => this.setState({logo:logo})}
                warning={validationMessages['brandLogo']}
                cropperAspectRatio={1/1}
                existingFileName={brandBeingEdited['logoFileName']}
                existingFileURL={brandBeingEdited['logoURL']}
              />
            </div>
          )}
        </div>
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;{isCreatingBrand?  'Create brand and save':'Save'}&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignBrandForm.defaultProps = {
  isShowingTutorial:true,
  canCreateNew:true,
  onBrandCreateSubmit:() => {},
  onBrandUpdateSubmit:() => {},
  onBrandChangeSubmit:() => {}
};

export default CampaignBrandForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignBrandForm.js